import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, watchEffect, onMounted } from "vue";
import Dialog from "./Dialog.vue";
import { isFunction } from "@/utils/isUtil";
export default {
  __name: 'ActivityConfirm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    desc: {
      type: String,
      default: ""
    },
    onOk: {
      type: Function,
      default: null
    },
    onCancel: {
      type: Function,
      default: null
    },
    okText: {
      type: String,
      default: ""
    },
    cancelText: {
      type: String,
      default: ""
    },
    withoutCancel: {
      type: Boolean,
      default: false
    },
    showBottomButton: {
      type: Boolean,
      default: true
    },
    disableOkButton: {
      type: Boolean,
      default: false
    },
    cancelOnClickOverlay: {
      type: Boolean,
      default: false
    },
    showAfterMounted: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var show = ref(false);
    watchEffect(function () {
      if (props.visible) {
        show.value = true;
      }
    });
    function ok() {
      return _ok.apply(this, arguments);
    }
    function _ok() {
      _ok = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!isFunction(props.onOk)) {
                _context.next = 4;
                break;
              }
              _context.next = 3;
              return props.onOk();
            case 3:
              res = _context.sent;
            case 4:
              if (res === false) {
                show.value = true;
              } else {
                show.value = false;
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _ok.apply(this, arguments);
    }
    onMounted(function () {
      if (props.showAfterMounted) {
        show.value = true;
      }
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Dialog, {
        visible: show.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return show.value = $event;
        }),
        title: __props.title,
        desc: __props.desc,
        "on-ok": ok,
        "on-cancel": _ctx.cancel,
        "ok-text": __props.okText,
        "cancel-text": __props.cancelText,
        "without-cancel": __props.withoutCancel,
        "show-bottom-button": __props.showBottomButton,
        "disable-ok-button": __props.disableOkButton,
        "cancel-on-click-overlay": __props.cancelOnClickOverlay
      }, null, 8, ["visible", "title", "desc", "on-cancel", "ok-text", "cancel-text", "without-cancel", "show-bottom-button", "disable-ok-button", "cancel-on-click-overlay"]);
    };
  }
};